export const CHECK_DEVICE = "CHECK_DEVICE";

export const DB_SYNC = "DB_SYNC";

export const CHANGE_SETPOINT = "CHANGE_SETPOINT";
export const FETCH_DATA = "FETCH_DATA";
export const FETCH_LOGS = "FETCH_LOGS";
export const FETCH_WEATHER = "FETCH_WEATHER";

export const STORE_DATA = "STORE_DATA";

export const HIT_CLIENT = "HIT_CLIENT";
export const HIT_DB = "HIT_DB";
export const HIT_LOGS = "HIT_LOGS";
export const HIT_MENU = "HIT_MENU";

export const INIT = "INIT";
export const INIT_DEMO = "INIT_DEMO";
export const DID_INIT = "DID_INIT";
export const GENERATE_DATA = "GENERATE_DATA";
export const IS_AUTHENTICATED = "IS_AUTHENTICATED";

export const RE_ROUTE = "RE_ROUTE";

export const SET_AUTH = "SET_AUTH";
export const SYNC = "SYNC";

//Toggles
export const CLOSE_MENU = "CLOSE_MENU";
export const OPEN_MENU = "OPEN_MENU";

export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";
export const OPEN_SNACKBAR = "OPEN_SNACKBAR";

export const TOGGLE_ADVANCED_SIGNUP = "TOGGLE_ADVANCED_SIGNUP";
export const TOGGLE_BUSINESS_OPTIONS = "TOGGLE_BUSINESS_OPTIONS";

export const RESET_APP = "RESET_APP";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_USER = "RESET_USER";

export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const UPDATE_CLIENT_USERS = "UPDATE_CLIENT_USERS";
export const UPDATE_LOGS = "UPDATE_LOGS";
export const UPDATE_USER = "UPDATE_USER";

//pages/LoginPage.js, pages/client_dashboard/ClientSignUp.js
export const HANDLE_FORMS = "HANDLE_FORMS";
export const LOG_OUT = "LOG_OUT";
export const SET_FORM_ERRORS = "SET_FORM_ERRORS";

export const SUBMIT_EDIT_PROFILE = "SUBMIT_EDIT_PROFILE";
export const SUBMIT_LOGIN = "SUBMIT_LOGIN";
export const SUBMIT_LOGOUT = "SUBMIT_LOGOUT";
export const SUBMIT_SIGNUP = "SUBMIT_SIGNUP";

export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE";
export const TOGGLE_USER_ACTIVE = "TOGGLE_USER_ACTIVE";

export const ACCOUNT = "ACCOUNT";
export const BAIL = "BAIL"; //eg: Bail out of auth producedures

//Dev
export const STORE_TEMP_POINT = "STORE_TEMP_POINT";



// WEBPACK FOOTER //
// ./src/actions/actionConstants.js